import * as less from './Shows.less';
import React from 'react';
import classnames from 'classnames';

export default class Shows extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.createOnLabelClick = this.createOnLabelClick.bind(this);
  }

  createOnLabelClick(id) {
    return (function onLabelClick(e) {
      e.preventDefault();

      this.props.actions.play(id);

    }).bind(this);
  }

  render() {
    const playlist = this.props.playlist.playlist;
    const isPlaying = this.props.playlist.isPlaying;

    const baseClassNames = 'call-out call-out-show dark';
    const golfChannelClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'golf-channel' });
    const burgerClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'burger' });
    const foundationClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'foundation' });
    const stonesThrowClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'stones-throw' });
    const minimalWaveClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'minimal-wave' });
    const soundwayClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'soundway' });
    const rockersClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'rockers' });
    const workshopClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'workshop' });
    const ppuClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'ppu' });
    const plantClassNames = classnames(baseClassNames, { 'solid': isPlaying && playlist.key === 'plant' });

    const streamStationClassNames = classnames('call-out call-out-show dark hidden-xs', {
      solid: !isPlaying
    });

    return (
      <div className='page-shows-container'>
        <div className='video-player-container'>
          <div className='static-image'></div>
        </div>

        <div className='page-shows'>
          <div className='station-links'>
            <div className={streamStationClassNames}><span className='title'>Select Station to Stream</span></div>
            <a href='#' className={golfChannelClassNames} onClick={this.createOnLabelClick('golf-channel')}><span className='title'>Golf Channel</span><span className='subtitle'>—House</span><span className='more-info'>NYC</span><span className='onair'>—on air</span></a>
            <a href='#' className={burgerClassNames} onClick={this.createOnLabelClick('burger')}><span className='title'>Burger</span><span className='subtitle'>—LO-FI</span><span className='more-info'>LA</span><span className='onair'>—on air</span></a>
            <a href='#' className={foundationClassNames} onClick={this.createOnLabelClick('foundation')}><span className='title'>Foundation</span><span className='subtitle'>—Experimental</span><span className='more-info'>Seoul</span><span className='onair'>—on air</span></a>
            <a href='#' className={stonesThrowClassNames} onClick={this.createOnLabelClick('stones-throw')}><span className='title'>Stones Throw</span><span className='subtitle'>—Hip-Hop</span><span className='more-info'>LA</span><span className='onair'>—on air</span></a>
            <a href='#' className={minimalWaveClassNames} onClick={this.createOnLabelClick('minimal-wave')}><span className='title'>Minimal Wave</span><span className='subtitle'>—Synth</span><span className='more-info'>NYC</span><span className='onair'>—on air</span></a>
            <a href='#' className={soundwayClassNames} onClick={this.createOnLabelClick('soundway')}><span className='title'>Soundway</span><span className='subtitle'>—Global Dance</span><span className='more-info'>London</span><span className='onair'>—on air</span></a>
            <a href='#' className={rockersClassNames} onClick={this.createOnLabelClick('rockers')}><span className='title'>Rockers Intl</span><span className='subtitle'>—Reggae</span><span className='more-info'>Kingston</span><span className='onair'>—on air</span></a>
            <a href='#' className={workshopClassNames} onClick={this.createOnLabelClick('workshop')}><span className='title'>Workshop</span><span className='subtitle'>—Techno</span><span className='more-info'>Berlin</span><span className='onair'>—on air</span></a>
            <a href='#' className={ppuClassNames} onClick={this.createOnLabelClick('ppu')}><span className='title'>PPU Records</span><span className='subtitle'>—Funk/Soul</span><span className='more-info'>DC</span><span className='onair'>—on air</span></a>
            <a href='#' className={plantClassNames} onClick={this.createOnLabelClick('plant')}><span className='title'>Plant Records</span><span className='subtitle'>—Hip-Hop</span><span className='more-info'>Osaka</span><span className='onair'>—on air</span></a>
            <div className='call-out call-out-show dark call-out-logo hidden-xs'></div>
          </div>
        </div>
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/routes/Shows.jsx
 **/